<template>
    <div>
        <p-header title="地址"/>
        <search-address
                class="search"
                ref="address"
                :isFocus="isFocus"
                :value="fullAddress"
                @onSelected="selectedPlace"
                @onFocus="searching = true"
                @onBlur="searching = false"/>
        <div class="input-data" v-show="! searching">
            <div class="item">
                <span>棟/ 樓/ 層/ 室/</span>
                <input type="text" v-model="address.additional" placeholder="A棟 B1 在超市旁邊">
            </div>
            <div class="item">
                <span>公司/ 大樓名稱</span>
                <input type="text" v-model="address.alias" placeholder="XX大樓">
            </div>
            <div class="item">
                <span>聯絡人姓名</span>
                <input type="text" v-model="address.name" placeholder="這個地點聯絡人是誰？">
            </div>
            <div class="item">
                <span>聯絡人電話</span>
                <input type="text" v-model="address.phone" placeholder="聯絡電話是多少？">
            </div>
            <div class="item">
                <span>備註</span>
                <a-textarea v-model="address.note" placeholder="關於此地點的其他需求"></a-textarea>
            </div>
        </div>
        <div class="detail" v-show="! searching">
            <div class="button" @click="send">
                確定
                <div @click.stop>
                    <loading loader="spinner"
                             :active="isLoading"
                             :width="25"
                             :height="25"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from './components/Header';
    import { mapActions, mapGetters } from 'vuex';
    import * as R from 'ramda';
    import SearchAddress from './components/task/SearchAddress';
    import AutoTextarea from './components/AutoHeighTextarea';
    import Loading from 'vue-loading-overlay';
    import Swal from 'sweetalert2'

    export default {
        name: 'Address',
        components: {
            'p-header': Header,
            'search-address': SearchAddress,
            'a-textarea': AutoTextarea,
            'loading': Loading,
        },
        data() {
            return {
                address: {},
                isFocus: false,
                searching: false,
                isLoading: false,
            }
        },
        computed: {
            fullAddress() {
                if (! this.address) {
                    return '';
                }

                return (this.address.city + this.address.district + this.address.road) || '';
            },
            ...mapGetters(['addressById'])
        },
        methods: {
            loadData(id) {
                let address = this.addressById(id) || {};

                if (! address.id) {
                    this.$router.replace({
                        name: 'home'
                    })
                }

                this.address = R.clone(address);
            },
            selectedPlace(place) {
                this.address.city = place.city;
                this.address.district = place.district;
                this.address.road = place.road;
                this.address.latitude = place.latitude;
                this.address.longitude = place.longitude;
                this.address.alias = place.alias;
            },
            send() {
                this.isLoading = true;

                if (this.address.id) {
                    return this.update();
                }

                return this.create();
            },
            create() {
                this.createAddress(this.address).then(() => {
                    this.isLoading = false;
                    this.$router.go(-1);
                }).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                    this.isLoading = false;
                })
            },
            update() {
                let payload = {
                    id: this.address.id,
                    data: this.address,
                };

                this.putAddress(payload).then(() => {
                    this.isLoading = false;
                    this.$router.go(-1);
                }).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                    this.isLoading = false;
                })
            },
            ...mapActions(['putAddress', 'createAddress', 'getAddresses'])
        },
        created() {
            if (this.$route.params.id) {
                this.getAddresses().then(() => {
                    this.loadData(this.$route.params.id);
                });
            } else {
                this.isFocus = true;
            }
        }
    };
</script>

<style lang="scss">
    .task {
        .item {
            textarea {
                min-height: 100px !important;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .search {
        margin: 10px 15px;
    }

    .input-data {
        margin: 15px;

        .item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 4px;
            background-color: rgba(255,255,255,1);
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
            margin-top: 5px;
            padding: 10px;

            span {
                margin-bottom: 10px;
                color: rgba(0,0,0,1);
                font-size: 14px;
                line-height: 20px;
            }

            input {
                width: 100%;
                font-size: 14px;
                line-height: 20px;
                border: none;
            }
        }
    }

    .detail {
        padding: 15px 25px;

        .title {
            color: rgba(0, 0, 0, 1);
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            text-align: left;
        }

        .item {
            display: flex;
            justify-content: space-between;
            color: rgba(74, 74, 74, 1);
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            padding: 13px 0;
            border-bottom: solid 1px rgba(221,221,221,1);

            &:nth-child(4) {
                border-bottom: none;
            }

            .span {
                width: 145px;
            }

            .input {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: calc(100% - 145px);
                text-align: right;
                font-size: 14px;
                line-height: 20px;

                &.placeholder {
                    color: rgba(155, 155, 155, 1);
                }

                input {
                    text-align: right;
                    width: 100%;
                    border: none;
                    font-size: 14px;

                    &::placeholder {
                        color: rgba(155, 155, 155, 1);
                    }
                }
            }
        }

        .button {
            height: 45px;
            border-radius: 35px;
            background-color: rgba(51,153,51,1);
            color: rgba(255,255,255,1);
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 15px 0;
        }
    }

    .note {
        position: relative;

        .err-msg {
            position: absolute;
            color: rgba(244,67,54,1) !important;
            font-size: 12px;
            font-weight: 500;
            line-height: 17px;
            bottom: -8px !important;
            margin: 0 !important;
        }

        .line {
            border: solid 2px white;
            position: absolute;
            width: 103px;
            bottom: -2px;
            left: 6px;
        }

        &.err {
            border: 2px solid rgba(255,153,153,1);
            box-shadow: 0 2px 8px 0 rgba(255,153,153,0.35);
        }
    }
</style>
